import { STATUS_META } from '../../features/cases/caseMeta.js';
import styles from './StatusBadge.module.css';

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, tone: 'slate' };
  return <span className={`${styles.badge} ${styles[meta.tone]}`}>{meta.label}</span>;
}

export default StatusBadge;
